import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/design-system";
import { Feedback } from "@/components/workflow/shared";
import { errorMessage } from "@/lib/api";
import { hasProcurement, procurement, type OrderSummary } from "@/lib/procurement";

export function OrderApproval({ order, onSaved }: { order: OrderSummary; onSaved: (message: string) => void }) {
  const { user } = useAuth();
  const [returning, setReturning] = useState(false), [note, setNote] = useState("");
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  if (!hasProcurement(user, "approve")) return null;
  async function act(action: "odobri" | "vrati") {
    if (busy || (action === "vrati" && !note.trim())) return;
    setBusy(true); setError("");
    try { await procurement.action(order.id, action, action === "vrati" ? { poruka: note.trim() } : {}); onSaved(action === "odobri" ? "Narudžba je odobrena." : "Narudžba je vraćena s porukom."); setReturning(false); }
    catch (cause) { setError(errorMessage(cause, "Odluka nije spremljena. Pokušajte ponovno.")); }
    finally { setBusy(false); }
  }
  return <div className="space-y-3"><Feedback error={returning ? null : error} /><div className="flex flex-wrap gap-3">
    <Button disabled={busy} onClick={() => void act("odobri")}>{order.trazi_naknadno_odobrenje ? "Odobri naknadno" : "Odobri"}</Button>
    {!order.trazi_naknadno_odobrenje && <Button disabled={busy} variant="secondary" onClick={() => setReturning(true)}>Vrati s porukom</Button>}
  </div>{returning && <Dialog title="Vrati s porukom" onClose={() => { if (!busy) setReturning(false); }}><form className="avm-procurement space-y-4" onSubmit={event => { event.preventDefault(); void act("vrati"); }}><Feedback error={error} /><label>Poruka<textarea required autoFocus value={note} onChange={event => setNote(event.target.value)} /></label><Button disabled={busy || !note.trim()} type="submit">Vrati s porukom</Button></form></Dialog>}</div>;
}
